import React, { MouseEvent } from 'react';

import { ModalClose, ModalContainer, Overlay } from './CommonModal';
import { useCoinContext } from '../../contexts/CoinContext';
import { CoinPacks } from '../../lib/coinPacks';
import MenuItem from '../coins/MenuItem';
import { useBackgroundContext } from '../../contexts/BackgroundContext';

import InlineSunshineCoin from 'Common/src/components/icons/InlineSunshineCoin';
import CloseIcon from 'Common/src/components/icons/CloseIcon';

interface Props {
  close: () => void;
  needed?: number;
}

const CoinMenuModal = ({ close, needed }: Props) => {
  const backgroundContext = useBackgroundContext();
  const coinContext = useCoinContext();

  const onModalClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  const balance = coinContext.getBalance();

  return <Overlay onClick={close}>
    <ModalContainer onClick={onModalClick}>
      <ModalClose onClick={close}><CloseIcon/></ModalClose>
      <h2>Buy coins</h2>
      <div>
        { needed !== undefined ? <>You need {needed} <InlineSunshineCoin color={backgroundContext.colors.text}/> to generate custom images.</> : null}
      </div>
      <div>
        You currently have {balance} <InlineSunshineCoin color={backgroundContext.colors.text}/> in your wallet.
      </div>

      { CoinPacks.map((coinPack) => <MenuItem
        key={coinPack.coinAmount}
        coinPack={coinPack}
      /> )}
    </ModalContainer>
  </Overlay>
};

export default CoinMenuModal;
